import React, { useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { hideSection } from '~data/actions/config';
import { reorder } from '~data/actions/tags';

import View from './view';
import Contextmenu from './contextmenu';

export default function TagsSection(props) {
  const dispatch = useDispatch();
  const [menu, setMenu] = useState(false);

  const onClick = useCallback(
    () =>
      dispatch(hideSection(props.item._id, !props.item.hidden)),
    [dispatch, props.item._id, props.item.hidden],
  );

  const onSortTagsById = useCallback(() => dispatch(reorder('_id')), [dispatch]);
  const onSortTagsByCount = useCallback(
    () => dispatch(reorder('-count')),
    [dispatch],
  );

  const onContextMenu = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    e.target.focus();
    setMenu(true);
  }, []);

  const onContextMenuClose = useCallback(() => setMenu(false), []);

  return (
    <>
      <View
        {...props}
        onClick={onClick}
        onContextMenu={onContextMenu}
      />

      {menu ? (
        <Contextmenu
          {...props}
          onContextMenuClose={onContextMenuClose}
          onClick={onClick}
          onSortTagsById={onSortTagsById}
          onSortTagsByCount={onSortTagsByCount}
        />
      ) : null}
    </>
  );
}
